import React, { useEffect, useState, useMemo } from 'react'
import ReactEcharts from "echarts-for-react";
import logo from "../../assets/images/vodafone-business-logo.png"

import businessiconwhite from "../../assets/images/report/business-icon-white.png";
import peopleiconwhite from "../../assets/images/report/people-icon-white.png";
import operatingmodeliconwhite from "../../assets/images/report/operating-model-icon-white.png";
import infraiconwhite from "../../assets/images/report/infra-icon-white.png";
import networkiconwhite from "../../assets/images/report/network-icon-white.png";
import securityiconwhite from "../../assets/images/report/security-icon-white.png";
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSurveyReport, getSurveySectionData, getSurveyResult, getSurveyDetail } from '../../store/actions/surveyFormAction';
import ReportPage from './components/ReportPage';
import ReportRenderer from './components/ReportRenderer';


export default function Report({ SRID }) {

    //States
    const [innerHtml1, setInnerHtml1] = useState(null)
    const [innerHtml2, setInnerHtml2] = useState(null)
    const [ids1, setIds1] = useState(null)
    const [ids2, setIds2] = useState(null)
    const [innerCss1, setInnerCss1] = useState(null)
    const [innerCss2, setInnerCss2] = useState(null)
    const [innerHtmlFlag, setInnerHtmlFlag] = useState(0)
    const { survey_id, ss_id, srid } = useParams();
    const [searchParams] = useSearchParams();
    const isPDF = searchParams.get('ispdf');
    const [isMobile, setIsMobile] = useState(false)
    const [leadArray, setLeadArray] = useState([])
    const [queArray, setQueArray] = useState([])


    const [assessment, setAssessment] = React.useState("");
    const [assessmentHeading, setAssessmentHeading] = React.useState("");
    const [stage, setStage] = React.useState("");
    const [stage1, setStage1] = React.useState("");
    const [stage2, setStage2] = React.useState("");
    const [stage3, setStage3] = React.useState("");
    const [stage4, setStage4] = React.useState("");
    const [stage5, setStage5] = React.useState("");

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const surveyReportData = useSelector((state) => state.surveyData?.surveyReport)
    const result = useSelector((state) => state.surveyData?.surveyResult)
    const surveySections = useSelector((state) => state.surveyData?.surveySections)
    const surveyDetail = useSelector((state) => state.surveyData?.surveyDetail)

    //Functionalities
    const decodeHTMLEntities = (text) => {
        let textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        return textArea.value;
    }

    const getSectionIcon = (index) => {
        const icons = [
            businessiconwhite,
            peopleiconwhite,
            operatingmodeliconwhite,
            infraiconwhite,
            networkiconwhite,
            securityiconwhite,
        ];
        return icons[index] || businessiconwhite; // Default to the first icon if index is out of range
    };
    //Effects
    useEffect(() => {
        const payload = {
            survey_id,
            srid: srid ?? SRID,
            ss_id
        }
        dispatch(getSurveyReport(payload))

        // Check if the window width is less than 768px (i.e., a mobile device)
        setIsMobile(window.innerWidth < 768);

        // Update the isMobile state variable whenever the window is resized
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);

        dispatch(getSurveySectionData({
            "survey_id": survey_id
        }))

        return () => window.removeEventListener('resize', handleResize);

    }, [SRID, srid, ss_id, survey_id])

    useEffect(() => {
        if (survey_id && ss_id) {
            dispatch(getSurveyResult({ survey_id, ss_id }))
        }
    }, [survey_id, ss_id])

    useEffect(() => {
        
            dispatch(getSurveyDetail({
                "survey_id": survey_id
            }));
        
    }, [survey_id]);
    

    useEffect(() => {
        if (surveyDetail?.length > 0) {
            console.log("survey detail-------", surveyDetail)
            // setTheme([surveyDetail[0].theme_selected]);
            setAssessment(surveyDetail[0].reportPage6_assessment);
            setAssessmentHeading(surveyDetail[0].reportPage6_assessmentHeading);
            setStage(surveyDetail[0].reportPage6_stage);
            setStage1(surveyDetail[0].reportPage6_stage1);
            setStage2(surveyDetail[0].reportPage6_stage2);
            setStage3(surveyDetail[0].reportPage6_stage3);
            setStage4(surveyDetail[0].reportPage6_stage4);
            setStage5(surveyDetail[0].reportPage6_stage5);
        }

    }, [surveyDetail])


    useEffect(() => {
        if (surveyReportData?.html) {
            const create1 = createPages(1)
            const create2 = createPages(2)
            setInnerHtml1(create1.objs)
            setInnerCss1(create1.cssObjs)
            setInnerHtml2(create2.objs)
            setInnerCss2(create2.cssObjs)
            setIds1(create1.idObj)
            setIds2(create2.idObj)
            setInnerHtmlFlag(1)
        }
        if (innerHtmlFlag == 1) {
            setLeadArray(surveyReportData.leadDom);
            setQueArray(surveyReportData.quesDom);
        }
    }, [innerHtmlFlag, surveyReportData])

    let createPages = function (type) {
        const objs = []
        const cssObjs = []
        const idObj = []
        Object.keys(surveyReportData.pages ?? {})?.forEach(function (key, index) {
            if ((type == 1 && key < 6) || (type == 2 && key > 6)) {
                surveyReportData.pages[key] = decodeHTMLEntities(surveyReportData.pages[key] ?? '')

                for (let x in surveyReportData.leadDom) {
                    surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll('#[leadForm:' + x + ']#', surveyReportData.leadDom[x]);
                }

                for (let x in surveyReportData.quesDom) {
                    surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll('#[' + x + ']#', surveyReportData.quesDom[x]);
                }
                for (let x in surveyReportData.quesVariableValues) {
                    let searchString = `#[${x}`;
                    if (surveyReportData.pages[key].includes(searchString)) {
                        const valuesOfSpecificKey = surveyReportData.quesVariableValues[x];
                        valuesOfSpecificKey.map((val) => {
                            if (surveyReportData.pages[key].includes(Object.keys(val)[1])) {
                                surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll(`${searchString}:${Object.keys(val)[1]}]#`, Object.values(val)[1]);
                            }
                        })
                    }
                }
                // surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll('../images', 'http://bis-frnt-dev.digitalapple.in/images');

                // objs.push(<span key={index} dangerouslySetInnerHTML={{ __html: surveyReportData.pages[key] }}></span>)
                objs.push(surveyReportData.pages[key])
                cssObjs.push(surveyReportData.css[key])
                idObj.push(key)
            }
        });
        return { objs, cssObjs, idObj }
    }


    //Colors
    const sectionColors = ['#9C2AA0', '#E60000', '#A8B400', '#EB9700', '#00B0CA', '#4A4D4E']

    //Options and style
    const style = {
        height: isMobile ? '250px' : '450px',
        width: '100%',
        // add the chart-container class
        className: 'chart-container',
    }

    const option = useMemo(() => {

        //Intervals and max value
        const interval = Number(result?.graph_interval ?? 3)
        const intervalCount = Number(result?.graph_interval_count ?? 100)
        const maxValue = interval * intervalCount

        //Functionalities
        const getIndicator = (name, colorIndex) => {
            return { name: name, max: maxValue, color: sectionColors[colorIndex] }
        }

        //Get sections and indicators 
        let indicators = []
        let values = []
        const sectionWithScore = result?.section_maturity_score

        Object.keys(sectionWithScore ?? {})?.forEach((key, index) => {
            indicators.push(getIndicator(surveySections[key]?.name, index))
            values.push(Number(sectionWithScore[key]))
        })

        indicators.push(indicators.shift())

        //Return if data
        if (indicators.length > 0 && values.length > 0) {
            values.push(values.shift())
            return {
                radar: {
                    indicator: indicators.reverse(),
                    name: {
                        textStyle: {
                            fontSize: isMobile ? 8 : 16,
                            fontWeight: 'bold',
                            className: 'chart-title',
                        },
                    },
                    splitNumber: intervalCount,
                },
                series: [
                    {
                        name: 'Digital Maturity Radar',
                        type: 'radar',
                        color: '#E60000',
                        areaStyle: { // added areaStyle option here
                            color: 'rgba(230, 0, 0, .2)', // set the background color of the plotted area
                        },
                        data: [
                            {
                                value: values.reverse()
                            }
                        ]
                    }
                ]
            }
        }

        //Return this id there isn't any data
        return {
            radar: {
                indicator: [{ name: '', max: 10 }, { name: '', max: 10 }, { name: '', max: 10 }],
                name: {
                    textStyle: {
                        fontSize: isMobile ? 12 : 16,
                        fontWeight: 'bold',
                        className: 'chart-title',
                    },
                },
            },
            series: [
                {
                    name: 'Digital Maturity Radar',
                    type: 'radar',
                    color: '#E60000',
                    areaStyle: { // added areaStyle option here
                        color: 'rgba(230, 0, 0, .2)', // set the background color of the plotted area
                    },
                    data: [
                        {
                            value: [0]
                        }
                    ]
                }
            ]
        }

    }, [surveySections, result, isMobile])

    const isLoading = !innerHtml1 || innerHtml1.length === 0;

    return (
        <>
            {isLoading && !isPDF && (
                <div className="report-loader-overlay">
                    <div className="report-loader-spinner"></div>
                    <div className="report-loader-text">Loading report...</div>
                </div>
            )}
            <div className="page-wrapper" id='surveyReport'>
                {innerHtml1?.map((html, index) => {
                    return (
                        <React.Fragment key={index * Math.random()}>
                            <ReportRenderer
                                pageHTML={html}
                                pageId={ids1[index]}
                                pageCss={innerCss1 && innerCss1[index]}
                            />
                        </React.Fragment>
                    )
                })}

                {surveyReportData && surveyReportData?.show_page6 !== 0 && <span>
                    <div className="content-main-section position-relative section-3 section-height">
                        <div className="content-wrapper">
                            <div className="text-wrap section-padding-left">
                                <div className="text-inner">
                                    {/* <div className="title"><span>03</span> {leadArray && leadArray['company']} {assessmentHeading}</div> */}
                                    <div className="title">{survey_id !== 'e14204f0-a57d-11ef-81e8-6daef271e3b2' && <><span>03</span> {leadArray && leadArray['company']}</>} {assessmentHeading}</div>

                                    {/* <div className="bold-text"><span>{leadArray && leadArray['firstName']} {leadArray && leadArray['lastName']}</span>,{assessment}</div> */}
                                    <div className="bold-text">{survey_id !== 'e14204f0-a57d-11ef-81e8-6daef271e3b2' && <><span>{leadArray && leadArray['firstName']} {leadArray && leadArray['lastName']}</span>,</>}{assessment}</div>

                                    <div className="chart-wrapper">
                                        <ReactEcharts style={style} option={option} />
                                    </div>
                                </div>
                            </div>
                            <div className="progress-wrapper section-padding-right">
                                <div className="progress-heading">
                                    <div className="heading-text">
                                        <p>{stage}</p>
                                        <h3 className='dangerouslySet' dangerouslySetInnerHTML={{ __html: queArray && decodeHTMLEntities(queArray['maturity_stage']) }}></h3>
                                    </div>
                                    <div className="percentage">{queArray && queArray['overall_percentage']}%</div>
                                </div>
                                <div className="progress-chart">
                                    {Object.keys(surveySections)?.map((sectionId, index) => {
                                        const section = surveySections[sectionId];
                                        const sectionName = section.name; // Access 'name' from the section object
                                        const sectionDescription = section.desc; // Access 'desc' from the section object
                                        const sectionOrder = section.order; // Access 'order' from the section object
                                        const sectionPercentage = surveyReportData?.section_percentages?.[sectionId] ?? 0;

                                        return (
                                            <div className="progress-list" key={sectionId}>
                                                <div className="icon-wrap">
                                                    <img src={getSectionIcon(index)} alt={sectionName} />
                                                </div>
                                                <div className="progress-wrap">
                                                    <div className="heading ">
                                                        <div className="pro-title">{sectionName}</div>
                                                        <div className="value">{sectionPercentage}%</div>
                                                    </div>
                                                    <div className="progress">
                                                        <div className="progress-bar" role="progressbar" style={{ width: `${sectionPercentage}%` }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="report-container position-abs-container">
                            <div className="page-counter">
                                <ul>
                                    <li>
                                        <span className="count">01</span>
                                        <p>{stage1}</p>
                                    </li>
                                    <li>
                                        <span className="count">02</span>
                                        <p>{stage2}</p>
                                    </li>
                                    <li className="active">
                                        <span className="count">03</span>
                                        <p>
                                             {stage3} {survey_id !== 'e14204f0-a57d-11ef-81e8-6daef271e3b2' && leadArray && leadArray['company']}
                                        </p>
                                    </li>
                                    <li>
                                        <span className="count">04</span>
                                        <p>{stage4}</p>
                                    </li>
                                    {survey_id !== 'e14204f0-a57d-11ef-81e8-6daef271e3b2' && (
                                    <li>
                                        <span className="count">05</span>
                                        <p>{stage5}</p>
                                    </li>
                                    )}
                                </ul>
                            </div>
                            <div className="vodafone-logo">
                                <img src={logo} alt='' />
                            </div>
                        </div>
                    </div>
                </span>}

                {innerHtml2?.map((html, index) => {
                    return (
                        <React.Fragment key={index * Math.random()}>
                            <ReportRenderer
                                key={index * Math.random()}
                                pageHTML={html}
                                pageId={ids2[index]}
                                pageCss={innerCss2 && innerCss2[index]}
                            />
                        </React.Fragment>
                    )
                })}
            </div>
        </>
    )
}
